import api from "shared/api";
import { User } from "shared/store/auth/types";
import { AxiosPromise } from "axios";

const prefix = "api/base";

export interface UserLoginStats extends User {
  last_login: Date;
  times_logged_in: number;
}

export const postRequestMagicLink = (
  email_address: string
): AxiosPromise<void> => {
  return api().post(`${prefix}/auth/request-magic-link`, { email_address });
};

export const postProcessMagicLink = (token: string): AxiosPromise<void> => {
  return api().post(`${prefix}/auth/process-magic-link`, { token });
};

export const postLoggedOut = (): AxiosPromise<void> => {
  return api().post(`${prefix}/auth/logout`);
};

export const getUserLoginStats = async (): Promise<UserLoginStats[]> => {
  try {
    const res = await api().get<UserLoginStats[]>(`${prefix}/auth/stats`);
    return res.data;
  } catch (e) {
    throw e;
  }
};
